<template>
  <div
    class="color-cell"
    :style="{ backgroundColor: cellData ? cellData : ''}"
  />
</template>

<script>
export default {
  name: 'ColorCell',

  props: {
    cellData: {
      type: String,
      default: ''
    }
  }
}
</script>

<style scoped>
.color-cell {
  border-radius: 12px;
  width: 30px;
  height: 30px;
}

@media screen and (max-width: 780px) {
  .color-cell {
    border-radius: 8px;
    width: 24px;
    height: 24px;
  }
}
</style>
